<template>
	<div class="platef">
		<!-- 车牌弹窗 -->
		<van-popup v-model:show="popupVisible" position="bottom" :close-on-click-overlay="false" @close="onPopupClose">
			<div class="popup">
				<!-- 弹窗头部 -->
				<div class="popup-header">
					<span class="title">请输入车牌信息</span>
					<span class="close-btn" @click="closePopup">×</span>
				</div>

				<!-- 车牌颜色选择 -->
				<div class="plate-color">
					<label class="color-label" :class="{ active: plateColor === '1' }">
						<input type="radio" :checked="plateColor === '1'" @change="changePlateColor('1')" />
						<span class="color-dot" style="background-color: #1CA6FF;"></span>
						<span>蓝牌</span>
					</label>
					<label class="color-label" :class="{ active: plateColor === '5' }">
						<input type="radio" :checked="plateColor === '5'" @change="changePlateColor('5')" />
						<span class="color-dot" style="background-color: #07C160;"></span>
						<span>绿牌</span>
					</label>
					<label class="color-label" :class="{ active: plateColor === '2' }">
						<input type="radio" :checked="plateColor === '2'" @change="changePlateColor('2')" />
						<span class="color-dot" style="background-color: #FFB800;"></span>
						<span>黄牌</span>
					</label>
					<label class="color-label" :class="{ active: plateColor === '3' }">
						<input type="radio" :checked="plateColor === '3'" @change="changePlateColor('3')" />
						<span class="color-dot" style="background-color: #FFFFFF; border: 2px solid #ccc;"></span>
						<span>白牌</span>
					</label>
					<label class="color-label" :class="{ active: plateColor === '4' }">
						<input type="radio" :checked="plateColor === '4'" @change="changePlateColor('4')" />
						<span class="color-dot" style="background-color: #333333;"></span>
						<span>黑牌</span>
					</label>
				</div>

				<!-- 车牌输入框区域 -->
				<div class="input-box">
					<div v-for="(char, index) in plateArray" :key="index" class="input-item"
						:class="{ active: isActiveIndex(index), filled: char !== '', selected: selectedIndex === index }"
						@click="selectInput(index)">
						{{ char }}
					</div>
					<!-- 分隔点 -->
					<!-- <span class="divider-dot" v-if="plateArray.length >= 2">·</span> -->
				</div>

				<!-- 分隔线 -->
				<div class="divider"></div>

				<!-- 键盘区域 -->
				<div class="keyboard">
					<!-- 省份选择（第一位） -->
					<div v-if="selectedIndex === 0 || plate.length === 0">
						<div class="keyboard-row">
							<div v-for="(it, key) in province.slice(0, 8)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<div class="keyboard-row">
							<div v-for="(it, key) in province.slice(8, 16)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<div class="keyboard-row">
							<div v-for="(it, key) in province.slice(16, 24)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<div class="keyboard-row">
							<div v-for="(it, key) in province.slice(24)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
					</div>
					<!-- 字母键盘（第二位） -->
					<div v-else-if="selectedIndex === 1 || plate.length === 1">
						<div class="keyboard-row">
							<div v-for="(it, key) in letter.slice(0, 8)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<div class="keyboard-row">
							<div v-for="(it, key) in letter.slice(8, 16)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<div class="keyboard-row">
							<div v-for="(it, key) in letter.slice(16, 24)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
					</div>
					<!-- 字母和数字键盘（第三位及以后） -->
					<div v-else>
						<!-- 字母第一行 -->
						<div class="keyboard-row">
							<div v-for="(it, key) in letter.slice(0, 8)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<!-- 字母第二行 -->
						<div class="keyboard-row">
							<div v-for="(it, key) in letter.slice(8, 16)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<!-- 字母第三行 -->
						<div class="keyboard-row">
							<div v-for="(it, key) in letter.slice(16, 24)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<!-- 数字行（1-8） -->
						<div class="keyboard-row">
							<div v-for="(it, key) in number.slice(0, 8)" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
						<!-- 数字行（9、0）+ 特殊字符（仅最后一位显示） -->
						<div class="keyboard-row keyboard-row-left">
							<div class="key-item" @click="addToPlate('9')">9</div>
							<div class="key-item" @click="addToPlate('0')">0</div>
							<!-- 只有最后一位时才显示中文特殊字符 -->
							<div v-if="isLastPosition" v-for="(it, key) in special" :key="key" class="key-item"
								@click="addToPlate(it)">
								{{ it }}
							</div>
						</div>
					</div>
				</div>

				<!-- 底部按钮 -->
				<div class="bottom-buttons">
					<button class="btn cancel" @click="closePopup">取消</button>
					<button class="btn delete" @click="deleteFromPlate">删除</button>
					<button class="btn confirm" @click="confirmPlate">完成</button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
export default {
	name: 'CsflPlate',
	props: {
		value: {
			type: Object,
			default: () => ({ plate: '', plateColor: '1' })
		},
		limit: {
			type: Number,
			default: 8
		}
	},
	data() {
		return {
			popupVisible: false,
			selectedIndex: -1, // 当前选中的输入框索引
			province: ["陕", "粤", "京", "冀", "沪", "津", "晋", "蒙", "辽",
				"吉", "黑", "苏", "浙", "皖", "闽", "赣", "鲁",
				"豫", "鄂", "湘", "桂", "琼", "渝", "川", "贵",
				"云", "藏", "甘", "青", "宁", "新"],
			letter: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
			number: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
			special: ["港", "澳", "学", "领", "警"]
		}
	},
	computed: {
		plate() {
			return this.value.plate || '';
		},
		plateColor() {
			return this.value.plateColor || '1';
		},
		plateData() {
			if (this.plate.length === 0) {
				return this.province;
			} else if (this.plate.length === 1) {
				return this.letter;
			} else {
				return [...this.letter, ...this.number];
			}
		},
		plateArray() {
			let arr = this.plate.split('');
			const len = this.plateColor === '5' ? 8 : 7;
			while (arr.length < len) {
				arr.push('');
			}
			return arr.slice(0, len);
		},
		isLastPosition() {
			const len = this.plateColor === '5' ? 8 : 7;
			// 根据选中位置或输入位置判断是否显示中文键盘
			const currentPos = this.selectedIndex !== -1 ? this.selectedIndex : this.plate.length;
			return currentPos >= len - 1;
		}
	},
	watch: {
		limit(val) {
			this.$emit('input', { ...this.value, plate: this.plate.substring(0, val) });
		}
	},
	methods: {
		openKeyboard() {
			// 保持已有的车牌值和颜色，不重置
			this.selectedIndex = -1;
			this.popupVisible = true;
		},

		selectInput(index) {
			// 点击已填充的输入框时选中它
			if (index < this.plate.length) {
				this.selectedIndex = index;
			}
		},

		isActiveIndex(index) {
			const len = this.plateColor === '5' ? 8 : 7;
			// 如果有选中的索引，选中项高亮
			if (this.selectedIndex !== -1) {
				return this.selectedIndex === index;
			}
			// 否则正常高亮：最后一位输入完时最后一位高亮，否则高亮下一个输入框
			if (this.plate.length === len) {
				return index === len - 1;
			}
			return index === this.plate.length;
		},

		addToPlate(value) {
			const len = this.plateColor === '5' ? 8 : 7;
			let newPlate = this.plate;
			// 如果有选中项，修改选中项
			if (this.selectedIndex !== -1) {
				if (this.selectedIndex >= len) return;
				const arr = newPlate.split('');
				arr[this.selectedIndex] = value;
				newPlate = arr.join('');
				// 如果选中项不是最后一位，选中下一个
				if (this.selectedIndex < len - 1) {
					this.selectedIndex++;
				}
			} else {
				// 正常输入逻辑
				if (newPlate.length + 1 > len) {
					// 输入已满，自动选中最后一位并修改
					const arr = newPlate.split('');
					arr[len - 1] = value;
					newPlate = arr.join('');
				} else {
					newPlate += value;
				}
			}
			this.$emit('input', { ...this.value, plate: newPlate });
		},

		deleteFromPlate() {
			let newPlate = this.plate;
			if (this.selectedIndex !== -1) {
				// 如果有选中项，删除选中项并选中前一个
				const arr = newPlate.split('');
				arr.splice(this.selectedIndex, 1);
				newPlate = arr.join('');
				if (this.selectedIndex > 0) {
					this.selectedIndex--;
				} else if (newPlate.length === 0) {
					this.selectedIndex = -1;
				}
			} else {
				// 正常删除逻辑
				newPlate = newPlate.slice(0, -1);
			}
			this.$emit('input', { ...this.value, plate: newPlate });
		},

		changePlateColor(color) {
			const newLen = color === '5' ? 8 : 7;
			let newPlate = this.plate;
			// 只有当从绿牌切换到其他颜色时才截断，从其他颜色切换到绿牌时不截断
			if (this.plateColor === '5' && color !== '5') {
				newPlate = this.plate.substring(0, newLen);
			}
			this.$emit('input', { plate: newPlate, plateColor: color });
		},

		closePopup() {
			this.popupVisible = false;
			this.selectedIndex = -1;
			this.onPopupClose();
		},

		confirmPlate() {
			this.popupVisible = false;
			this.selectedIndex = -1;
			this.onPopupClose();
		},

		onPopupClose() {
			this.$emit('close', this.value);
		}
	}
}
</script>

<style scoped lang="scss">
.popup {
	background-color: #fff;
	width: 100%;
	border-radius: 16px 16px 0 0;
	padding-bottom: env(safe-area-inset-bottom);
}

.popup-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	border-bottom: 1px solid #f0f0f0;

	.title {
		font-size: 18px;
		font-weight: 600;
		color: #333;
	}

	.close-btn {
		width: 32px;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 24px;
		color: #999;
		cursor: pointer;
	}
}

.plate-color {
	display: flex;
	justify-content: space-around;
	padding: 16px 20px;
	border-bottom: 1px solid #f0f0f0;

	.color-label {
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
		flex: 1;

		input {
			display: none;
		}

		.color-dot {
			width: 32px;
			height: 32px;
			border-radius: 50%;
			margin-bottom: 8px;
			border: 3px solid transparent;
			transition: all 0.2s;
		}

		span:last-child {
			font-size: 14px;
			color: #666;
		}

		&.active {
			.color-dot {
				border-color: #10AEFF;
				box-shadow: 0 0 0 2px rgba(16, 174, 255, 0.2);
			}

			span:last-child {
				color: #10AEFF;
				font-weight: 500;
			}
		}
	}
}

.input-box {
	display: flex;
	justify-content: space-around;
	padding: 10px 10px;
	align-items: center;

	.input-item {
		width: 40px;
		height: 40px;
		background-color: #f5f5f5;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 24px;
		font-weight: bold;
		color: #333;
		border: 2px solid transparent;
		transition: all 0.2s;
		cursor: pointer;

		&.active {
			background-color: #10AEFF;
			color: #fff;
		}

		&.filled:not(.active) {
			background-color: #fff;
			border-color: #e0e0e0;
		}

		&.selected {
			background-color: #10AEFF;
			color: #fff;
			border-color: #10AEFF;
		}
	}

	.divider-dot {
		font-size: 24px;
		color: #ccc;
		margin: 0 4px;
	}
}

.divider {
	height: 12px;
	background-color: #f5f5f5;
	margin: 0 20px;
	border-radius: 6px;
}

.keyboard {
	padding: 12px 12px;

	.keyboard-row {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: 6px;

		&:last-child {
			margin-bottom: 0;
		}

		&.keyboard-row-left {
			justify-content: flex-start;
			gap: 10px;
		}
	}

	.key-item {
		width: calc((100% - 50px) / 9);
		height: 40px;
		background-color: #fff;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-weight: 500;
		color: #333;
		cursor: pointer;
		transition: all 0.2s;

		&:active {
			background-color: #f0f0f0;
		}
	}
}

.bottom-buttons {
	display: flex;
	padding: 16px 20px;
	gap: 12px;

	.btn {
		flex: 1;
		height: 48px;
		border-radius: 8px;
		border: none;
		font-size: 16px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.2s;

		&.cancel {
			background-color: #f5f5f5;
			color: #666;
		}

		&.delete {
			background-color: #FFEBEB;
			color: #E53935;
		}

		&.confirm {
			background-color: #10AEFF;
			color: #fff;
		}

		&:active {
			opacity: 0.8;
		}
	}
}
</style>
